import styled from 'styled-components';

export const SubmitedDetails = styled.section`
  display: flex;
  background: white;
  border-radius: 0.4rem;
  padding: 2rem;
  flex-direction: column;
  margin-bottom: 2rem
`;
export const BusDetails = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 2rem
`
export const BusName = styled.span(
    props => `
    font-family:${props.theme.font.fontFamily};
    color: #141823;
    font-size: 1.6rem;
    font-weight: bold;
    padding-right: 1rem;
`
);
export const BusType = styled.span`
    padding-right: 1rem;
    color: #777;
    font-size: 1.2rem;
`
export const LocationDetails = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 2rem;
    flex: 1
`
export const LocationWrap = styled.div`
    width: 50%;
`
export const Time = styled.p(
props => `
    font-family:${props.theme.font.fontFamily};
    color: #777;
    font-size: 1.4rem;
    font-weight: bold;
`
);
export const LocationName = styled.p(
    props => `
    font-family:${props.theme.font.fontFamily};
    color: #141823;
    font-size: 1.6rem;
    font-weight: bold;
    padding-right: 1rem;
`
);
export const PassengerDetails = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0.5rem 0;
    
`
export const TravellerTitle = styled.span`
    color: #777;
    font-size: 1.2rem;
    display: flex;
    flex:1;
`
export const TravellerList = styled.div(
props => `
    display: flex;
    flex: 5;
    ul{
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        
        li{
            padding-right: 2rem;
            font-family:${props.theme.font.fontFamily};
            color: #777;
            font-size: 1.4rem;
            font-weight: bold;
            flex-direction: row;
            align-items: center;
            display: flex;
            padding-bottom: 0.5rem
        }
    }
`
);
export const GoSafeTag = styled.div`

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5rem;
    background: #e9f6ea;
    span{
        color: #777;
        font-size: 1.2rem;
        padding-left: 0.5rem;
    }
`
export const Bullet = styled.span`
    font-size: 0.4rem;
    padding-right: 0.5rem;
    color: #2276e3;
`
export const ContactPerson = styled.div`
    display: flex;
    flex-direction: column;
    display: flex;
    flex: 5;

`
export const ContactName = styled.p(
    props => `
        color: black;
        font-size: 1.5rem;
        font-weight: bold;
        font-family:${props.theme.font.fontFamily};
    `
);

export const PhoneNum = styled.p(
    props => `
        color: #777;
        font-size: 1.4rem;
        font-weight: bold;
        font-family:${props.theme.font.fontFamily};
    `
);
export const EmailId = styled.p(
    props => `
        color: #777;
        font-size: 1.4rem;
        font-weight: bold;
        font-family:${props.theme.font.fontFamily};
        padding-left:1rem;
    `
);


export const AmenitiesWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
export const SelectedAmenities = styled.div`
    border-top: 1px solid #e5e5e5;
    padding-top: 1.5rem;
    display: flex;
    flex-direction: row;
`
export const AmenitiesTxt = styled.span`
    font-size: 1.4rem;
    color: #777;
    padding-right: 2rem;
`
export const AmenitiesTabs = styled.div`
  padding: 0.2rem 0.5rem;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 0.5rem;
  background-image: linear-gradient(78deg, #00c57e, #18a160);
  span {
    color: white;
    font-weight: bold;
    font-size: 1.1rem;
    padding-left: 0.5rem;
  }
`;

export const LocationAddress = styled.p`
  font-size: 1.2rem;
  color: #777;
  padding-top: 0.5rem
`

